function mergeStyles(classes, styles) {
  if (!classes || !(typeof styles === "object" && styles !== null)) {
    return {};
  }
  return Object.keys(classes).reduce((acc, className) => {
    acc[className] = styles[className];
    return acc;
  }, {});
}

export { mergeStyles };
//# sourceMappingURL=merge-styles.js.map
